/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  INetworkMethods,
  NetworkService,
  LoadingService,
  ILoadingMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
} from "./components";

export type IssuedNetworkPageAgent = IHeaderMethods &
  INetworkMethods &
  NetworkService &
  IStaticPageContentMethods &
  ILoadingMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new NetworkService(),
    new LoadingService(),
    new StaticPageContentService(),
  ];
};

export const getAgent = () => {
  return createAgent<IssuedNetworkPageAgent>({
    plugins: getPlugins(),
  });
};
